// Message-template placeholder tags + renderer.
// Tags are written in templates as {TagName} and replaced case-insensitively.
export const TEMPLATE_TAGS = [
  { tag: "{CPName}", label: "CP name" },
  { tag: "{CPCompany}", label: "CP company" },
  { tag: "{CPCity}", label: "CP city" },
  { tag: "{CPPhone}", label: "CP phone" },
  { tag: "{CPEmail}", label: "CP email" },
  { tag: "{Training}", label: "Selected training" },
  { tag: "{Link}", label: "Onboarding link" },
  { tag: "{YourName}", label: "Your name" },
];

export function renderTemplate(body, vars = {}) {
  const map = {
    cpname: vars.cpName || "",
    cpcompany: vars.cpCompany || "",
    cpcity: vars.cpCity || "",
    cpphone: vars.cpPhone || "",
    cpemail: vars.cpEmail || "",
    training: vars.training || "",
    link: vars.link || "",
    yourname: vars.yourName || "",
  };
  return String(body || "").replace(/\{(\w+)\}/g, (m, k) => map[k.toLowerCase()] ?? m);
}

// Normalize an Indian phone for wa.me links: 10-digit numbers get the +91 prefix.
export const waPhone = (phone) => {
  let d = String(phone || "").replace(/\D/g, "");
  if (d.length === 10) d = "91" + d;
  return d;
};
